// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1Naxx","errorLogs":"styles_errorLogs__1vMly"};